<!-- <caloudi-webchat-bot></caloudi-webchat-bot> -->

<prime-main *ngIf="!layoutService.config.layoutType"></prime-main>
<tabmenu-main *ngIf="layoutService.config.layoutType === layoutService.layoutTypes.TABMENU"></tabmenu-main>
